import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QRCodeService {
  constructor(private httpWrapperService: HttpWrapperService) {}

  getQRCodeBasedOnUrl(routeString: string): Observable<string> {
    const url = 'QRCode';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = { 
        url: url,
        headers: headers,
        body: {data : routeString},
    };

    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: string) => response)
    );
  }
}